import type { LiteSecodaEntity } from '@repo/api-codegen';
import type { ISecodaEntity } from '../../api';
import type { PropertySelectorProps } from './PropertySelector';
import { PropertySelector } from './PropertySelector';

export interface GovernancePropertySelectorProps
	extends Pick<
		PropertySelectorProps,
		'onChange' | 'options' | 'position' | 'withinPortal'
	> {
	entity: ISecodaEntity | LiteSecodaEntity;
	viewerOfEntity: boolean;
}

export function GovernancePropertySelector({
	entity,
	viewerOfEntity,
	withinPortal,
	...propertySelectorProps
}: GovernancePropertySelectorProps) {
	return (
		<PropertySelector
			selected={!!entity.pii}
			type="single"
			value="pii"
			iconType="tabler"
			isViewerUser={viewerOfEntity}
			readOnly={viewerOfEntity}
			withinPortal={withinPortal}
			{...propertySelectorProps}
		/>
	);
}
